import React from "react";
import { PropTypes } from 'prop-types';
import {
  CollapseWrap,
  PillButtonSelect,
  Title,
  DisplayFlexAlign,
  Percentage,
  UnderlinelinkRemove,
  Check,
  ContentWrap,
  AccordionStatus,
  AccordionStatusText,
  AccordionBtnWrapper
} from "./styles";
import AccordionContent from "../AccordionContent/AccordionContent";
import { connect } from "react-redux";
import Popup from "../../../Step1Setup/Components/Popup/Popup";
import {
  removeValues,
  showRemainingPercentage,
  getAccordionStatus,
  toggleStepTwoUpdateButton,
  updateErrorState,
  updateAccordionState
} from "../../../actions";
import { initiateTracking, recordError } from "../../../../../../utils/commonUtil";

import IncompleteIcon from '../../../../../../assets/icons/incompleteError.svg';
import completeIcon from '../../../../../../assets/icons/confirmation-tick.svg';
import ToJS from "../../../../../Contributions/Pages/ContributionsDashboard/HOC/toJS";
import { getAlert, mapContents } from "../../../Step1Setup/Components/UtilFunctions";
import { basicAlertContents, dataLegacy, basicSingleLegacy } from "../../../DefaultPropTypes";
import { CapsuleButton } from "../../../../../../CommonComponents/Commons/commonComponents";
import { DisplayFlex } from "../../../../../../CommonComponents/commonStyles";
import { LegacyAccordionsTwoStates } from "../../../selectors";

export class LegacyAccordions extends React.Component {
  state = {
    open: false,
    show: false,
    displayType: "none",
    alertStatus: false,
    removePopupContent: {
      heading: "Remove Information",
      line1: "Are you sure you want to remove information?",
      line2: "",
      continue: "continue",
      cancel: "No, take me back",

      
      type: "removeInfo"
    }
  };

  

  handleChange = async e => {
    if(this.props.stepperUpdateIndex.status){
      this.props.toggleStepTwoUpdateButton(true);
    }
    if(this.props.contentKey === 1 || this.props.contentKey === 2 || this.props.contentKey === 4){
      let legacyValues =  this.props.legacy.legacyOptions;
      let contentKey = this.props.contentKey;
      let state = [...this.props.accordionState]; 
      /** Need to remove the error when user has clicked "Show Less" in any accordion */
      if(state[contentKey-1] === 3){
        /** re-setting the accordion state back to 0 */
        let contentKey = this.props.contentKey;
        let state = [...this.props.accordionState];
        state[contentKey-1] = 0;
        this.props.updateAccordionState(state);
        /** Checking if the percentage error is there, and then setting it as null */
        if(legacyValues[contentKey - 1].percentageError){
          legacyValues[contentKey - 1].percentageError = null;
        }
        /** Looping through the successor advisor to check if there is any error and set it as null */
        let successAdv = legacyValues[contentKey-1].successorAdvisor.successorAdvisor;
        for (let key of Object.keys(successAdv)) {
          for (let ikey of Object.keys(successAdv[key])) {
            if(ikey.includes('Error')){
              successAdv[key][ikey] = null;      
            }
            if(ikey === 'address'){
              for(let akey of Object.keys(successAdv[key][ikey])){
                if(akey.includes('Error')){
                  successAdv[key][ikey][akey] = null;      
                }
              }
            }
          }	        
        }
        /** Setting Error Messages in Reducer */
        await this.props.updateErrorState([null,legacyValues]); // - 5s
      }
    }
    this.hideElement();
  };

  hideElement = () => {
    let classId = document.getElementById(this.props.id);
    classId.scrollIntoView(0);
    if (this.props.accordionOpenStatus) {
      this.setState({
        open: !this.state.open,
        displayType: "none"
      });
    } else {
      this.setState({
        open: !this.state.open,
        displayType: "block"
      });
    }
    this.props.getAccordionStatus(true);
  }



  getPercentage = arr => {
    let percentage = "";
    arr && arr.forEach(val => {
      if (val.optionId == this.props.contentKey) {
        percentage = val.percentage;
      }
    });
    if (percentage == "") {
      return 0;
    } else {
      return percentage;
    }
  };

  closeModal = () => {
    this.setState({
      show: false
    });
  };

  handleRemoveState = () => {
    this.setState({
      show: true
    });
  };
  handleRemove = () => {
    initiateTracking('remove', 'Open Additional Account', 'Step 2 Legacy options - ' + this.getTabName(), 'Remove');
    this.setState({
      show: false
    });

    /** re-setting the accordion state back to 0 */
    let contentKey = this.props.contentKey;
    let state = [...this.props.accordionState];
    state[contentKey-1] = 0;
    this.props.updateAccordionState(state);
    let obj = this.props.legacy.legacyOptions;
    obj.forEach(val => {
      delete val.percentageError;
      delete val.duplicateAdvisorError;
      if (val.optionId == this.props.contentKey) {
        if (this.props.contentKey == 3 || this.props.contentKey == 5) {
          val.percentage = "";
        } else {
          val.percentage = "";
          val.successorAdvisor.successorAdvisor = [
            {
              key: "1",
              firstName: "",
              gender: "",
              dob: "",
              lastName: "",
              middleName: "",
              preferedEmail: "",
              preferedPhone: "",
              relationshipType: "",
              suffix: "",
              title: "",
              address: {
                city: "",
                country: "0",
                line1: "",
                line2: "",
                line3: "",
                state: "",
                zip: ""
              }
            }
          ];
        }
      }
    });

    this.props.removeValues({
      legacyOptions: obj
    });
    this.props.showRemainingPercentageFunc({
      showRemainingPercentage: true,
      key: this.props.contentKey,
      value: false
    });
  };

  getTabName(){
    switch(this.props.contentKey){
      case 1: return 'Appoint up to 2 individuals';
      case 2: return 'Create accounts';
      case 3: return 'Philanthropic Impact Fund';
      case 4: return 'Give to multiple charities';
      default: return 'Grant annually';
    }
  }

  handleSelect = (buttonName,analyticsEvent) => {
    try {
      /** setting the accordion state back to 3 [i.e. touched] */
      let contentKey = this.props.contentKey;
      let state = [...this.props.accordionState];
      state[contentKey-1] = 3;
      this.props.updateAccordionState(state);

      initiateTracking(analyticsEvent, 'Open Additional Account', 'Step 2 Legacy options - '+ this.getTabName(), buttonName);
      this.setState({
        displayType: "block",
        open: !this.state.open
      });
      this.props.getAccordionStatus(false);
    } catch (error) {
      recordError(error);
    }
  };

  getErrorClassName = () => {
    let accordion = this.props.accordionState[this.props.contentKey - 1];
    if(accordion === 1 || accordion === 3){
      return "error-state-accordion";
    }
    return null;
  }

  render() {
    let w = window.innerWidth;
    let percent;
    if (this.props.isStep2Edit) {
      percent = this.getPercentage(this.props.tempData.tempJSON.legacyOptions);
    } else {
      percent = this.getPercentage(this.props.legacy.legacyOptions);
    }

    const { alertOOA } = this.props;
    const { alertStatus, removePopupContent } = this.state;
    
    if(alertOOA && alertOOA.length && !alertStatus){
      this.setState({
        removePopupContent: mapContents(getAlert(alertOOA,'Remove Information'), removePopupContent),
        alertStatus: true
      })
    }
    return (
      <CollapseWrap>
        {this.state.show === true ? (
          <Popup
            height="313px"
            width="481px"
            mwidth="88%"
            mheight="53%"
            content={removePopupContent}
            closeModal={this.closeModal}
            handleRemove={this.handleRemove}
          />
        ) : null}
        <div>
          <DisplayFlexAlign className={this.getErrorClassName()} 
            displayType={this.state.displayType} 
            status = {this.props.accordionState[this.props.contentKey - 1] === 1}>
            <div id={this.props.id}>
              <Title>{this.props.content.heading}</Title>
              {w <= 768 ? (
                percent > 0 ? (
                  <Percentage marginRight="48px" textColor="#69923a">
                    {percent}%
                  </Percentage>
                ) : (
                  <Percentage marginRight="48px" textColor="#d4d4d4">
                    {percent}%
                  </Percentage>
                )
              ) : null}
              <ContentWrap>{this.props.content.content}</ContentWrap>
                {w > 768 ? (
                percent > 0 ? (
                  <Percentage marginRight="48px" textColor="#69923a">
                    {percent}%
                  </Percentage>
                ) : (
                  <Percentage marginRight="48px" textColor="#d4d4d4">
                    {percent}%
                  </Percentage>
                )
              ) : null}
              
              {this.state.open ? null : this.props.showRemainingPercentage ? (
                <DisplayFlex>
                  <AccordionBtnWrapper>
                    <CapsuleButton 
                      text = 'View and Edit'
                      data-test="view-and-edit"
                      onClick = {() => this.handleSelect('View and Edit','buttonStep')}
                      id = {"btnViewAndEdit"+this.props.id}
                      whiteBackground = {true}
                    />
                  </AccordionBtnWrapper>
                  <UnderlinelinkRemove onClick={this.handleRemoveState} id={"anrRemove"+this.props.id}>
                    Remove
                  </UnderlinelinkRemove>
                </DisplayFlex>

              ) : (
                <AccordionBtnWrapper>
                  <CapsuleButton 
                    text = 'Select'
                    data-test="select"
                    onClick = {() => this.handleSelect('Select','select')}
                    id = {"btnSelect"+this.props.id}
                    whiteBackground = {true}
                  />
                </AccordionBtnWrapper>
              )}
            </div>

            {this.props.accordionState[this.props.contentKey - 1] === 1 && (
              <AccordionStatus>
                <img src={IncompleteIcon} alt="Incomeplete" width="36" height="36"/>
                <AccordionStatusText color="#f5222d">Incomplete</AccordionStatusText>
              </AccordionStatus>
            )}
            {this.props.accordionState[this.props.contentKey - 1] === 2 && (
              <AccordionStatus>
                <img src={completeIcon} alt="Complete" width="36" height="36"/>
                <AccordionStatusText color="#69923a">Complete</AccordionStatusText>
              </AccordionStatus>
            )}
            
          </DisplayFlexAlign>
          <Check displayType={this.state.displayType}> 
            <AccordionContent
              handleChange={this.handleChange}
              head={this.props.content.heading}
              contentKey={this.props.contentKey}
            />
          </Check>
        </div>
      </CollapseWrap>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  legacy: state.getIn(["npaFormReducer", "legacyOptions", "legacyOptions"]),
  legacyValues: state.getIn([
    "npaFormReducer",
    "legacyOptions",
    "legacyOptions",
    "legacyOptions",
    `${ownProps.contentKey - 1}`
  ]),
  showRemainingPercentage: state.getIn([
    "npaFormReducer",
    "showRemainingPercentage",
    `showRemainingPercentage${ownProps.contentKey}`
  ]),
  tempData: state.getIn(["npaFormReducer", "tempJSON", "tempJSON"]),
  ...LegacyAccordionsTwoStates(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
  removeValues: val => dispatch(removeValues(val)),
  showRemainingPercentageFunc: val => dispatch(showRemainingPercentage(val)),
  getAccordionStatus: val => dispatch(getAccordionStatus(val)),
  toggleStepTwoUpdateButton: val => dispatch(toggleStepTwoUpdateButton(val)),
  updateErrorState: val => dispatch(updateErrorState(val)),
  updateAccordionState: val => dispatch(updateAccordionState(val))
});

LegacyAccordions.propTypes = {
  accordionOpenStatus: PropTypes.bool,
  accordionState: PropTypes.any,
  alertOOA: basicAlertContents,
  content: PropTypes.shape({
    content: PropTypes.any,
    heading: PropTypes.string,
  }),
  contentKey: PropTypes.number,
  getAccordionStatus: PropTypes.func,
  hasFieldValues: PropTypes.bool,
  id: PropTypes.string,
  isStep2Edit: PropTypes.any,
  legacy: dataLegacy,
  legacyValues: basicSingleLegacy,
  removeValues: PropTypes.func,
  showRemainingPercentage: PropTypes.bool,
  showRemainingPercentageFunc: PropTypes.func,
  stepperUpdateIndex: PropTypes.any,
  tempData: PropTypes.any,
  toggleStepTwoUpdateButton: PropTypes.func,
  updateAccordionState: PropTypes.func,
  updateErrorState: PropTypes.func,
}

export default ToJS(connect(
  mapStateToProps,
  mapDispatchToProps
)(LegacyAccordions));
